
export default {
    props: {
        entry: {
            type: Object,
            required: true,
            default: null
        }
    },

    computed: {
        heroImage() {
            if (!this.entry) {
                return;
            }

            if (this.entry.heroImages && this.entry.heroImages.length > 0) {
                return this.entry.heroImages[0];
            }

            // Fall back on featured image
            if (this.entry.featuredImages && this.entry.featuredImages.length > 0) {
                return this.entry.featuredImages[0];
            }

            return false;
        }
    }
};
